import { LiveVideoFlight } from "@nova/protobuf"
import { generateGenericCases } from "../../generateCases"
import { Builder } from "../../sockets"
import {
    CreateLiveVideoFlightArgs,
    getDefaultLiveVideoFlightCreateArgs,
    UpdateLiveVideoFlightArgs,
} from "@nova/serializer/src/client/validators/flights/liveVideo"
import {
    addEntitySocket,
    deleteEntitySocket,
    updateEntitySocket,
} from "features/entity-caching/project/slice"
import { v4 as randomUUID } from "uuid"
import { selectLiveVideoFlights } from "features/entity-caching/flights/selectors"
import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"
import { selectSingleLayer } from "panels/content/side-panel/slice.new"
// import { activateSidePanelModal } from "panels/content/side-panel/thunks"
import { flightIdContainer } from "panels/content/side-panel/modals/live-video/SpurAviation"
import { activateSidePanelModal } from "panels/content/side-panel/thunks"

const {
    create: createVideoFlight,
    update: updateVideoFlight,
    delete: deleteVideoFlight,
    createAction,
    updateAction,
    deleteAction,
} = generateGenericCases<
    LiveVideoFlight, // entity type
    CreateLiveVideoFlightArgs, // create args to send to server
    ["createdBy", "name", "saveRecording", "isMMA"], // create args required by action
    UpdateLiveVideoFlightArgs,
    void,
    { workspaceId?: string } // update args
>("LiveVideoFlight")

export const addLiveVideoFlightsToBuilder = (builder: Builder) =>
    builder
        .addCase(
            createAction,
            (
                store,
                {
                    payload: {
                        data: { createdBy, name: providedName, saveRecording, isMMA },
                    },
                },
                socket
            ) => {
                const state = store.getState()
                const flights = selectLiveVideoFlights(state)
                const name =
                    providedName || `Live Stream Flight ${Object.values(flights).length + 1}`
                const args = { name, id: randomUUID(), createdBy, saveRecording, isMMA }
                const optimisticData = {
                    ...args,
                    ...getDefaultLiveVideoFlightCreateArgs(state.project.data),
                }
                const workspaceId = selectActiveWorkspaceId()(state)

                createVideoFlight(socket, args, { workspaceId })
                store.dispatch(
                    addEntitySocket({
                        data: optimisticData,
                        path: ["liveVideoFlights"],
                    })
                )

                store.dispatch(selectSingleLayer({ id: optimisticData.id }))
                if (!isMMA) {
                    store.dispatch(
                        activateSidePanelModal({
                            id: optimisticData.id,
                            type: "layer",
                            layerContentType: "live",
                        })
                    )
                }
                flightIdContainer.id = optimisticData.id
            }
        )
        .addCase(updateAction, (store, { payload: { id, updates } }, socket) => {
            updateVideoFlight(socket, id, updates, {})
            store.dispatch(updateEntitySocket({ updates, path: ["liveVideoFlights", { id }] }))
        })
        .addCase(deleteAction, (store, { payload: { id } }, socket) => {
            deleteVideoFlight(socket, id, {})
            store.dispatch(deleteEntitySocket({ path: ["liveVideoFlights", { id }] }))
        })
export {
    createAction as createLiveVideoFlight,
    updateAction as updateLiveVideoFlight,
    deleteAction as deleteLiveVideoFlight,
}
